import gql from 'graphql-tag';

export default {
  getMyCampaigns: gql`
    fragment Email_getMyCampaigns on Campaign {
      secondaryCallToAction {
        id
        type
        data
      }
    }
  `,
};
